import { createBrowserRouter, Navigate, useRouteError } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import { GuestRoutes, AuthRoutes } from "./routes";
import { isCounterDashboard } from "../utility/authHelper";
import CounterLayout from "../layouts/CounterLayout";
import CounterRoutes from "./counter-routes";

const Routes = createBrowserRouter([
    ...[
        {
            path: "/",
            element: isCounterDashboard() ? <CounterLayout /> : <AuthLayout />,
            errorElement: <ErrorBoundary />,
            children: isCounterDashboard()
                ? [...CounterRoutes]
                : [...AuthRoutes],
        },
    ],
    ...GuestRoutes,
]);

function ErrorBoundary() {
    const error = useRouteError();
    if (error.status === 404) return <Navigate to="/error-404" />;
    else throw error;
}
export default Routes;
